import { createContext } from 'react';
import { BalanceMenu } from 'moduleBase/types/Menu';

type MenuBalanceContextType = {
  menu: BalanceMenu;
  show: () => void;
  hide: () => void;
  isOpen: boolean;
};

const MenuBalanceContext = createContext<MenuBalanceContextType>(null);

export {
  MenuBalanceContextType,
  MenuBalanceContext,
};
